module.exports = __webpack_public_path__ + "static/intro-background-mobile-5ce9d275bae5c9666b2acb4863fa2a20.jpg";